import React, { Component } from 'react'
import { CREATE_POINTS_UPLOAD_OPTION, DELETE_POINTS_UPLOAD_OPTION, POINTS_UPLOAD_OPTION_QUERY, UPDATE_POINTS_UPLOAD_OPTION } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock } from "react-icons/fa";
import PointsUploadOption from './PointsUploadOption';
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaPlus, FaSave, FaTrash } from "react-icons/fa";
import { AUTH_TOKEN } from '../../constants';
import { flattenStrapiData } from '../../utils/utilities';

class PointsUploadOptionList extends Component {
  state = {
    locked: true,
    error: ""
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
        <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
        <br/>
        <div><span className="error">{this.state.error}</span></div>
        <GetList
          token={token} 
          locked={this.state.locked}
        />
      </div>
    )
  }
}

function GetList({locked, token}) {
  const {data, loading, error, refetch} = useQuery(POINTS_UPLOAD_OPTION_QUERY)
  
  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">{error.message}</span>)
  
  let pointsUploadOptions = data?.pointsUploadOptions?.data

  return (
    <table className="table table-bordered">
      <tbody>
        <tr>
          <td><h4>Id</h4></td>
          <td><h4>PointValue</h4></td>
          <td><h4>Price</h4></td>
          <td><h4>Currency</h4></td>
          {token && !locked &&
          <td><h4>Edit/Add</h4></td>}
          {token && !locked &&
          <td><h4>Delete</h4></td>}
        </tr>
        {pointsUploadOptions.map(pointsUploadOption => {
          pointsUploadOption = flattenStrapiData(pointsUploadOption)
          return <PointsUploadOption 
          key={pointsUploadOption.id} 
          locked={locked} 
          pointsUploadOption={pointsUploadOption}>
            <Delete refetch={() => refetch()}/>
            <Update refetch={() => refetch()}/>
          </PointsUploadOption>
        })}
        {!locked && <PointsUploadOption 
        locked={locked}>
          <Add refetch={() => refetch()}/>
        </PointsUploadOption>}
      </tbody>
    </table>
  )
}

function Add({state, refetch, cleanState}) {
  const [createPointsUploadOption, {loading, error}] = useMutation(CREATE_POINTS_UPLOAD_OPTION)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Create Mutation Error: "+error.message)

  return (
      <IconButton onClick={e => createPointsUploadOption({variables: {point_value: parseInt(state.point_value) , price: parseInt(state.price), currency: state.currency}})
      .then(data => {
        cleanState()
        refetch()
      })
      .catch(e => alert("Execute Add Mutation Error: "+e))}><FaPlus/></IconButton>
  )
}

function Delete({id, refetch}) {
  const [deletePointsUploadOption, {loading, error}] = useMutation(DELETE_POINTS_UPLOAD_OPTION)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Delete Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => deletePointsUploadOption({variables: {id: id}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaTrash/></IconButton>
  )
}

function Update({id, state, refetch}) {
  const [updatePointsUploadOption, {loading, error}] = useMutation(UPDATE_POINTS_UPLOAD_OPTION)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Update Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => updatePointsUploadOption({variables: {id: id, point_value: parseInt(state.point_value) , price: parseInt(state.price), currency: state.currency}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaSave/></IconButton>
  )
}


export default PointsUploadOptionList